/* eslint-disable react/require-default-props */
import React from 'react';
import LetterAvatar from '@components/Avatar/LetterAvatar';
import { Button, ButtonVariant } from '@components/Button';
import Chip from '@components/Chip/chip';
import StatusIcon from '@components/StatusIcon/StatusIcon';
import ImageAvatar from '@components/Avatar/ImageAvatar';
import TooltipText from '@components/v2/TooltipText';
import UiSizes from '@enums/UiSizes';
import { translate } from '@utils/i18n';
import camelToCapitalize from '@utils/functions/camelToCapitalize';
import { VersionEvent } from '../../types';
import { IndexNamespace } from '../../constants';
import dateFormatter from '../../utils/dateFormatter';
import getStatusUpdate from '../../utils/getStatusUpdate';
import getVersionDetails from '../../utils/getVersionDetails';
import VersionDetails from './VersionDetails';
const versionEventMap = {
    [VersionEvent.Create]: translate('created', { namespace: IndexNamespace }),
    [VersionEvent.Update]: translate('details_updated', { namespace: IndexNamespace }),
    [VersionEvent.MarkedAsResolved]: translate('marked_as_resolved', { namespace: IndexNamespace }),
    [VersionEvent.MarkedAsUnresolved]: translate('marked_as_unresolved', { namespace: IndexNamespace })
};
function StatusUpdateComp({ prev, new: newStatus }) {
    if (!prev || !newStatus) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("span", null, translate('status_changed_from', { namespace: IndexNamespace })),
        React.createElement(Chip, { icon: React.createElement(StatusIcon, { status: prev }), label: prev.label }),
        React.createElement("span", null, translate('to', { namespace: IndexNamespace })),
        React.createElement(Chip, { icon: React.createElement(StatusIcon, { status: newStatus }), label: newStatus.label })));
}
export default function Version({ version }) {
    var _a, _b;
    const [showDetails, setShowDetails] = React.useState(false);
    const detailsToShow = getVersionDetails(version);
    const infoText = getStatusUpdate(version) ? (React.createElement(StatusUpdateComp, { prev: (_a = getStatusUpdate(version)) === null || _a === void 0 ? void 0 : _a[0], new: (_b = getStatusUpdate(version)) === null || _b === void 0 ? void 0 : _b[1] })) : (`${camelToCapitalize(version.itemType)} ${versionEventMap[version.event]} ${version.author.name ? `by ${version.author.name}` : ''}`);
    return (React.createElement("div", { className: "activity__item versionContainer" },
        React.createElement("div", { className: "versionContent" },
            React.createElement("div", { className: "versionAvatarContainer" },
                version.author.avatar && (React.createElement(ImageAvatar, { src: version.author.avatar, borderColor: version.author.color || '#bbb', size: UiSizes.medium })),
                version.author.name && !version.author.avatar && (React.createElement(LetterAvatar, { letter: version.author.name[0], backgroundColor: version.author.color || '#bbb', size: UiSizes.medium })),
                !version.author.name && !version.author.avatar && !version.author.type && (React.createElement("span", { className: `qmb-avatar--${UiSizes.medium}`, style: {
                        backgroundColor: '#bbb',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    } },
                    React.createElement("i", { className: "fa-solid fa-users-gear", style: { color: '#fff' } })))),
            React.createElement("div", { className: "versionInfoContainer" },
                React.createElement("span", null, infoText),
                detailsToShow.length > 0 && (React.createElement(Button, { variant: ButtonVariant.Link, onClick: () => setShowDetails(!showDetails) }, translate(showDetails ? 'hide_details' : 'show_details', { namespace: IndexNamespace })))),
            React.createElement("div", { className: "activity__date" },
                React.createElement(TooltipText, { text: new Date(version.createdAt).toLocaleString() },
                    React.createElement("span", null, dateFormatter(new Date(version.createdAt)))))),
        showDetails && React.createElement(VersionDetails, { details: detailsToShow, version: version })));
}
